import { gql } from '@apollo/client';
import { changeBrowserLanguage, getCurrentLanguage, graphqlLocaleToI18n } from '@modernloop/i18n';

import { useEmployeeLocaleQuery } from 'src/generated/mloop-graphql';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const EmployeeLocaleQuery = gql`
  query EmployeeLocale {
    thisEmployee {
      id
      locale
    }
  }
`;

/**
 * Syncs the i18n locale with the employee's locale from the backend.
 * On load, fetches the employee's locale via onCompleted. If it differs
 * from the current i18n locale, switches to it. localStorage is updated
 * as a side effect of changeBrowserLanguage().
 */
export function useSyncEmployeeLocale(): void {
  useEmployeeLocaleQuery({
    onCompleted: (data) => {
      const backendLocale = data?.thisEmployee?.locale;
      if (!backendLocale) {
        return;
      }

      const i18nLocale = graphqlLocaleToI18n(backendLocale);
      if (!i18nLocale) {
        return;
      }

      const currentLocale = getCurrentLanguage();
      if (currentLocale !== i18nLocale) {
        changeBrowserLanguage(i18nLocale);
      }
    },
  });
}
